import { useTranslation } from "react-i18next";
import {
  TranslationNamespaceEnum,
  TranslationNamespaceEnum as TNS,
} from "src/lib/i18next/types.ts";
import { loadTranslations } from "src/lib/i18next/loadTranslations.ts";
import { Button } from "src/components/Button/Button.tsx";
import { H3 } from "src/components/Heading/Heading.tsx";
import { TextV2 } from "src/components/TextV2/TextV2.tsx";
import { TooManyRequests } from "src/components/QueryError/components/TooManyRequests/TooManyRequests.tsx";
import { isThrottled } from "src/lib/throttling.ts";

await loadTranslations(TranslationNamespaceEnum.ErrorBoundaryComponent);

export const DefaultErrorBoundary = ({
  error,
  onReset,
}: {
  error?: unknown;
  onReset?: () => void;
}) => {
  const { t } = useTranslation(TNS.ErrorBoundaryComponent);

  // Лимит запросов — не поломка: сервер попросил подождать, и об этом надо
  // сказать словами со сроком, а не «что-то пошло не так».
  if (isThrottled(error)) {
    return <TooManyRequests error={error} onReset={onReset} />;
  }

  return (
    <div
      css={{
        height: "100%",
        width: "100%",
        alignContent: "center",
        textAlign: "center",
      }}
    >
      <H3 style={{ marginTop: 16 }}>{t("title")}</H3>
      <div style={{ marginTop: 4 }}>
        <TextV2 variant={"body1"}>{t("subtitle")}</TextV2>
      </div>

      {onReset && (
        <div
          style={{
            marginTop: 4,
            display: "inline-block",
          }}
        >
          <Button size={"sm"} onClick={() => onReset?.()}>
            Retry
          </Button>
        </div>
      )}
    </div>
  );
};
